import React from 'react';
import styled from 'styled-components';
import media from '../../utils/media';
import HorizontalCard from './HorizontalCard';
import { ComponentHeader } from '../ComponentWrappers';
import { getFieldValue, defineRegionFieldFromTitle, defineAriaLabelFromTitle } from '../../utils/helpers';
import { isFieldValid } from '../../utils/validation';
import { COLOR_MAPPING_CARDS } from '../../constants';
import { COMPONENT_MARGIN_BOTTOM } from '../../constants';
const Container = styled.div `
  outline: none;
  margin-top: ${({ hasNegativeMargin }) => hasNegativeMargin ? `calc(-30px - ${COMPONENT_MARGIN_BOTTOM.DESKTOP}px)` : ''};
  position: relative;
  width: 100%;
  height: auto;
  background: transparent;
  text-align: center;
  justify-content: center;
  align-items: center;
  margin-bottom: ${`${COMPONENT_MARGIN_BOTTOM.DESKTOP}px`};
  ${media.mobile} {
    margin-top: ${({ hasNegativeMargin }) => hasNegativeMargin ? `calc(-30px - ${COMPONENT_MARGIN_BOTTOM.MOBILE}px)` : ''};
    width: 100%;
    display: grid;
    margin: auto;
    margin-bottom: ${`${COMPONENT_MARGIN_BOTTOM.MOBILE}px`};
  }
`;
const CardsContainer = styled.div `
  display: flex;
  width: auto;
  max-width: 1110px;
  margin-right: auto;
  margin-left: auto;

  @media (max-width: 992px) {
    margin-right: 15px;
    margin-left: 15px;
    flex-wrap: wrap;
  }
  ${media.mobile} {
    max-width: 100%;
  }
`;
export const HorizontalCards = ({ fields }) => {
    if (!fields) {
        return React.createElement("div", null);
    }
    const { componentTitle, componentSubtitle, componentNegativeMargin, items, ariaLabel } = fields;
    const cardItems = items.map((card, key) => {
        const { fields } = card;
        const color = COLOR_MAPPING_CARDS[key];
        return key < 4 ? React.createElement(HorizontalCard, { key: key, fields: fields, color: color && color }) : null;
    });
    const margin = getFieldValue(componentNegativeMargin);
    const hasComponentHeader = !margin && isFieldValid(componentTitle);
    return items.length >= 2 ? (React.createElement(ComponentHeader, { title: hasComponentHeader && componentTitle, subtitle: componentSubtitle, ariaLabel: ariaLabel },
        React.createElement(Container, { hasNegativeMargin: margin, role: defineRegionFieldFromTitle(componentTitle), "aria-label": defineAriaLabelFromTitle(componentTitle, ariaLabel) },
            React.createElement(CardsContainer, null, cardItems)))) : null;
};
export default HorizontalCards;
